import React, { useEffect } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Paper } from "@mui/material";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { RequirementTableHeader } from "../../../../components/datagrid/EmployeeService/Requirement/RequirementTableHeader";
import AddOrUpdateRequirementRequest from "./AddOrUpdateRequirementRequest";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAllProductsWithoutPagination, getProductListForAddRequirement, getSale } from "../../../../redux/features/assetManagementSlice";
import ActionDetails from "../../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../../components/mui/GlobalAnchor/GlobalAnchorList";
import DeleteRequirement from "./DeleteRequirement";
import ApproveRequirement from "./ApproveRequirement";
import RejectRequirement from "./RejectRequirement";

const RequirementView = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;

  const { loading, saleDetails } = useSelector(
    (store) => store.assetmanagement
  );
  const dispatchParams = {
    paginationData,
  };

  useEffect(() => {
     dispatch(getProductListForAddRequirement());
  }, [])
  
  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getSale(dispatchParams));
    }
  }, [gridSize, pageNum, search]);
  return (
    <GlobalWrapper
      title={"Requirement"}
      actions={
        <AddOrUpdateRequirementRequest dispatchParams={dispatchParams} />
      }
    >
      <Box>
        <Paper>
          <GlobalDatagrid
            tableHead={RequirementTableHeader({ procurement: false })}
            rows={saleDetails?.data}
            meta={saleDetails?.meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.subCategoryName} />
                <GlobalAnchorList
                  component={
                    <AddOrUpdateRequirementRequest
                      dispatchParams={dispatchParams}
                      row={rowData}
                      disable={rowData?.isHeadApproved != 0}
                      isNotRequestRaiser={!rowData?.isRequestGenerated}

                    />
                  }
                />
                <GlobalAnchorList
                  label={"Action"}
                  component={
                    <DeleteRequirement
                      dispatchParams={dispatchParams}
                      saleId={rowData?.salesID}
                      disable={rowData?.isHeadApproved != 0}
                      isNotRequestRaiser={!rowData?.isRequestGenerated}
                    />
                  }
                />
                {rowData?.isHead && (
                  <GlobalAnchorList
                    label={"Action"}
                    component={
                      <ApproveRequirement
                        dispatchParams={dispatchParams}
                        saleId={rowData?.salesID}
                        disable={rowData?.isHeadApproved != 0}
                      />
                    }
                  />

                )}
                {rowData?.isHead && (
                  <GlobalAnchorList
                    label={"Action"}
                    component={
                      <RejectRequirement
                        dispatchParams={dispatchParams}
                        saleId={rowData?.salesID}
                        disable={rowData?.isHeadApproved != 0}
                      />
                    }
                  />
                )}

              </>
            }
          />
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default RequirementView;
